import { auth } from "./firebase";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut/**, onAuthStateChanged*/ } from "firebase/auth";

// Verificar si el usuario está autenticado
export const isAuthenticated = () => {
  return !!auth.currentUser;
};

// Función para iniciar sesión
export const login = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
    return true;
  } catch (error) {
    console.error("Error al iniciar sesión:", error);
    return false;
  }
};

// Función para registrarse
export const register = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const token = await userCredential.user.getIdToken();
    localStorage.setItem("authToken", token);
    return true;
  } catch (error) {
    console.error("Error al registrarse:", error);
    return false;
  }
};

// Función para cerrar sesión
export const logout = async () => {
  try {
    await signOut(auth);
    localStorage.removeItem("authToken");
  } catch (error) {
    console.error("Error al cerrar sesión:", error);
  }
};
